import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCostCenterReport,
  getParticularPage,
  getNext,
  getPrevious,
  createCostCenterReport,
  updateCostCenterReport,
  handleSearch,
} from "./thunk";

const initialState = {
  costCenterReports: [],
  edit: false,
  costCenterReport: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCostCenterReport: false,
  loadingNext: false,
  showCreateModal: false,
};

export const costCenterReportSlice = createSlice({
  name: "costCenterReport",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    costCenterReportEditSuccess: (state, action) => {
      state.edit = true;
      state.costCenterReport = state.costCenterReports.find(
        (costCenterReport) => costCenterReport.id === action.payload
      );
    },
    clearAllCostCenterReport: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCostCenterReport = false;
      state.costCenterReport = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCostCenterReport.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCostCenterReport.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCostCenterReport.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenterReport.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCostCenterReport.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCostCenterReport.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCostCenterReport.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCostCenterReport = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenterReport.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCostCenterReport = false;
        state.costCenterReports = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCostCenterReport.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCostCenterReport = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, costCenterReportEditSuccess, clearAllCostCenterReport } =
  costCenterReportSlice.actions;

export default costCenterReportSlice.reducer;
